// import React, { useEffect, useMemo, useState } from 'react';
// import apiWithAuth from '../../services/apiWithAuth';
// import './VisitorAnalytics.css';

// function formatDate(iso) {
//   if (!iso) return '-';
//   try {
//     return new Date(iso).toLocaleString('en-IN', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//     });
//   } catch {
//     return iso;
//   }
// }

// function formatNumber(num) {
//   if (!num) return '0';
//   return num.toLocaleString('en-IN');
// }

// function formatDuration(ms) {
//   if (!ms || ms === 0) return '-';
//   // Handle both direct ms values and eventParams.time_spent_ms
//   const totalMs = typeof ms === 'number' ? ms : 0;
//   if (totalMs === 0) return '-';
//   const seconds = Math.floor(totalMs / 1000);
//   if (seconds < 60) return `${seconds}s`;
//   const minutes = Math.floor(seconds / 60);
//   if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
//   const hours = Math.floor(minutes / 60);
//   return `${hours}h ${minutes % 60}m`;
// }

// function getEventDuration(event) {
//   // Try to get duration from eventParams first
//   if (event.eventParams?.time_spent_ms) {
//     return formatDuration(event.eventParams.time_spent_ms);
//   }
//   if (event.eventParams?.session_duration_ms) {
//     return formatDuration(event.eventParams.session_duration_ms);
//   }
//   // Fallback to duration field
//   return formatDuration(event.duration);
// }

// function getDeviceIcon(deviceType) {
//   switch (deviceType?.toLowerCase()) {
//     case 'mobile':
//       return '📱';
//     case 'tablet':
//       return '📱';
//     case 'desktop':
//       return '💻';
//     default:
//       return '❓';
//   }
// }

// function getPageBadgeColor(pageName) {
//   const colors = {
//     home: '#3b82f6',
//     shop: '#8b5cf6',
//     product: '#ec4899',
//     category: '#f59e0b',
//     cart: '#10b981',
//     checkout: '#ef4444',
//     profile: '#6366f1',
//   };
//   return colors[pageName?.toLowerCase()] || '#6b7280';
// }

// export default function VisitorAnalytics() {
//   const [adminKey, setAdminKey] = useState('');
//   const [search, setSearch] = useState('');
//   const [limit, setLimit] = useState(100);
//   const [loading, setLoading] = useState(false);
//   const [summaryLoading, setSummaryLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [rows, setRows] = useState([]);
//   const [summary, setSummary] = useState(null);
//   const [hasLoaded, setHasLoaded] = useState(false);
//   const [autoRefresh, setAutoRefresh] = useState(true);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const hasRows = useMemo(() => rows.length > 0, [rows]);

//   const loadData = async () => {
//     setLoading(true);
//     setError('');
//     try {
//       const qs = new URLSearchParams({
//         limit: String(limit || 100),
//         ...(search.trim() && { search: search.trim() }),
//         ...(adminKey.trim() && { adminKey: adminKey.trim() }),
//       });
      
//       const response = await apiWithAuth.get(
//         `/website-main/visitor-events?${qs.toString()}`,
//         {
//           headers: adminKey.trim() ? { 'x-admin-key': adminKey.trim() } : {},
//         }
//       );
      
//       const json = response.data;
//       if (!json?.success) {
//         throw new Error(json?.error || 'Failed to fetch visitor logs');
//       }
      
//       // Combine registered users and guests
//       const allUsers = [
//         ...(Array.isArray(json.data) ? json.data : []),
//         ...(Array.isArray(json.guests) ? json.guests : []),
//       ];
      
//       setRows(allUsers);
//       setHasLoaded(true);
//     } catch (e) {
//       setRows([]);
//       setError(e?.message || 'Failed to fetch visitor logs');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadSummary = async () => {
//     setSummaryLoading(true);
//     try {
//       const qs = new URLSearchParams({
//         ...(adminKey.trim() && { adminKey: adminKey.trim() }),
//       });

//       const response = await apiWithAuth.get(
//         `/website-main/visitor-events/summary?${qs.toString()}`,
//         {
//           headers: adminKey.trim() ? { 'x-admin-key': adminKey.trim() } : {},
//         }
//       );

//       const json = response.data;
//       if (json?.success) {
//         setSummary(json.data);
//       }
//     } catch (e) {
//       console.error('Failed to load summary:', e);
//     } finally {
//       setSummaryLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//     loadSummary();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     if (!autoRefresh) return undefined;
//     const interval = setInterval(() => {
//       loadData();
//       loadSummary();
//     }, 2000);
//     return () => clearInterval(interval);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [autoRefresh, adminKey, search, limit]);

//   return (
//     <div className="visitor-analytics">
//       <div className="va-container">
//         {/* Header */}
//         <div className="va-header">
//           <div>
//             <h1 className="va-title">Visitor Analytics</h1>
//             <p className="va-subtitle">
//               Real-time tracking of user interactions and page visits
//             </p>
//           </div>
//         </div>

//         {/* Summary Cards */}
//         {summary && (
//           <div className="va-summary-cards">
//             <div className="va-card">
//               <div className="va-card-icon">📊</div>
//               <div className="va-card-content">
//                 <h3 className="va-card-label">Total Events</h3>
//                 <p className="va-card-value">{formatNumber(summary.totalEvents)}</p>
//               </div>
//             </div>

//             <div className="va-card">
//               <div className="va-card-icon">👥</div>
//               <div className="va-card-content">
//                 <h3 className="va-card-label">Unique Users</h3>
//                 <p className="va-card-value">{formatNumber(summary.uniqueUsers)}</p>
//               </div>
//             </div>

//             <div className="va-card">
//               <div className="va-card-icon">📄</div>
//               <div className="va-card-content">
//                 <h3 className="va-card-label">Top Page</h3>
//                 <p className="va-card-value">
//                   {summary.topPages?.[0]?._id || '-'}
//                 </p>
//                 <p className="va-card-count">
//                   {formatNumber(summary.topPages?.[0]?.count || 0)} visits
//                 </p>
//               </div>
//             </div>

//             <div className="va-card">
//               <div className="va-card-icon">⚡</div>
//               <div className="va-card-content">
//                 <h3 className="va-card-label">Top Event</h3>
//                 <p className="va-card-value">
//                   {summary.topEvents?.[0]?._id || '-'}
//                 </p>
//                 <p className="va-card-count">
//                   {formatNumber(summary.topEvents?.[0]?.count || 0)} times
//                 </p>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Controls */}
//         <div className="va-controls">
//           <div className="va-control-group">
//             <input
//               type="password"
//               value={adminKey}
//               onChange={(e) => setAdminKey(e.target.value)}
//               placeholder="Admin key (if enabled)"
//               className="va-input"
//             />
//             <input
//               type="text"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//               placeholder="Search by name, email, phone, event, or page..."
//               className="va-input va-input-wide"
//             />
//             <div className="va-control-actions">
//               <input
//                 type="number"
//                 min={1}
//                 max={500}
//                 value={limit}
//                 onChange={(e) => setLimit(Number(e.target.value || 100))}
//                 className="va-input-number"
//               />
//               <button
//                 type="button"
//                 onClick={() => {
//                   loadData();
//                   loadSummary();
//                 }}
//                 disabled={loading || summaryLoading}
//                 className="va-btn va-btn-primary"
//               >
//                 {loading || summaryLoading ? '⏳ Loading...' : '🔄 Load'}
//               </button>
//             </div>
//           </div>

//           <div className="va-refresh-toggle">
//             <span className="va-refresh-label">
//               Auto-refresh every 2s
//               {autoRefresh && <span className="va-pulse">●</span>}
//             </span>
//             <button
//               type="button"
//               onClick={() => setAutoRefresh((v) => !v)}
//               className={`va-btn ${autoRefresh ? 'va-btn-pause' : 'va-btn-resume'}`}
//             >
//               {autoRefresh ? '⏸ Pause' : '▶ Resume'}
//             </button>
//           </div>
//         </div>

//         {/* Error Message */}
//         {error && (
//           <div className="va-error">
//             <span>⚠️ {error}</span>
//             <button onClick={() => setError('')} className="va-error-close">
//               ✕
//             </button>
//           </div>
//         )}

//         {/* Table */}
//         <div className="va-table-wrapper">
//           <table className="va-table">
//             <thead>
//               <tr>
//                 <th>User</th>
//                 <th>Email</th>
//                 <th>Phone</th>
//                 <th>Total Events</th>
//                 <th>First Seen</th>
//                 <th>Last Seen</th>
//                 <th>Device Types</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {!hasRows && (
//                 <tr className="va-empty-row">
//                   <td colSpan={8}>
//                     {hasLoaded
//                       ? '📭 No records found. Try adjusting your filters.'
//                       : '⏳ Loading visitor logs...'}
//                   </td>
//                 </tr>
//               )}
//               {rows.map((user) => (
//                 <tr key={user.userId || 'guest'} className="va-data-row">
//                   <td className="va-user">
//                     <div className="va-user-info">
//                       <div className="va-user-name">
//                         {user.isGuest ? '👤 Guest Users' : user.fullName || '-'}
//                       </div>
//                       {!user.isGuest && user.userId && (
//                         <div className="va-user-id">ID: {user.userId.slice(-6)}</div>
//                       )}
//                     </div>
//                   </td>
//                   <td className="va-email">{user.email || '-'}</td>
//                   <td className="va-phone">{user.phone || '-'}</td>
//                   <td className="va-events">{formatNumber(user.stats.totalEvents)}</td>
//                   <td className="va-first-seen">{formatDate(user.stats.firstSeen)}</td>
//                   <td className="va-last-seen">{formatDate(user.stats.lastSeen)}</td>
//                   <td className="va-devices">
//                     <span className="va-device-badges">
//                       {user.activity.deviceTypes.map((device, index) => (
//                         <span key={index} className="va-device-badge">
//                           {getDeviceIcon(device)} {device}
//                         </span>
//                       ))}
//                     </span>
//                   </td>
//                   <td className="va-action">
//                     <button
//                       type="button"
//                       onClick={() => {
//                         setSelectedUser(user);
//                         setShowModal(true);
//                       }}
//                       className="va-btn-details"
//                     >
//                       View Activity
//                     </button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Footer */}
//         <div className="va-footer">
//           <span className="va-count">
//             Showing <strong>{rows.length}</strong> record{rows.length === 1 ? '' : 's'}
//           </span>
//         </div>

//         {/* Details Modal */}
//         {showModal && selectedUser && (
//           <div className="va-modal-overlay" onClick={() => setShowModal(false)}>
//             <div className="va-modal va-modal-large" onClick={(e) => e.stopPropagation()}>
//               <div className="va-modal-header">
//                 <h2>User Activities</h2>
//                 <button
//                   type="button"
//                   onClick={() => setShowModal(false)}
//                   className="va-modal-close"
//                 >
//                   ✕
//                 </button>
//               </div>

//               <div className="va-modal-content">
//                 <div className="va-modal-grid">
//                   {/* User Info */}
//                   <div className="va-modal-section">
//                     <h3 className="va-modal-section-title">User Information</h3>
//                     <div className="va-modal-fields">
//                       <div className="va-modal-field">
//                         <label>Name</label>
//                         <span>{selectedUser.isGuest ? 'Guest' : selectedUser.fullName || '-'}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Phone</label>
//                         <span>{selectedUser.phone || '-'}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Email</label>
//                         <span>{selectedUser.email || '-'}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>User ID</label>
//                         <span className="va-monospace">{selectedUser.userId || '-'}</span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Stats */}
//                   <div className="va-modal-section">
//                     <h3 className="va-modal-section-title">Statistics</h3>
//                     <div className="va-modal-fields">
//                       <div className="va-modal-field">
//                         <label>Total Events</label>
//                         <span>{formatNumber(selectedUser.stats.totalEvents)}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>First Seen</label>
//                         <span>{formatDate(selectedUser.stats.firstSeen)}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Last Seen</label>
//                         <span>{formatDate(selectedUser.stats.lastSeen)}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Total Duration</label>
//                         <span>{formatDuration(selectedUser.stats.totalDuration)}</span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Activity Summary */}
//                   <div className="va-modal-section">
//                     <h3 className="va-modal-section-title">Activity Summary</h3>
//                     <div className="va-modal-fields">
//                       <div className="va-modal-field">
//                         <label>Event Names</label>
//                         <span>{selectedUser.activity.eventNames.join(', ') || '-'}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Page Names</label>
//                         <span>{selectedUser.activity.pageNames.join(', ') || '-'}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Shop Names</label>
//                         <span>{selectedUser.activity.shopNames.join(', ') || '-'}</span>
//                       </div>
//                       <div className="va-modal-field">
//                         <label>Device Types</label>
//                         <span>{selectedUser.activity.deviceTypes.join(', ') || '-'}</span>
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Recent Events */}
//                 <div className="va-modal-section va-modal-section-full">
//                   <h3 className="va-modal-section-title">Recent Activities</h3>
//                   <div className="va-events-table-wrapper">
//                     <table className="va-events-table">
//                       <thead>
//                         <tr>
//                           <th>Time</th>
//                           <th>Event</th>
//                           <th>Page</th>
//                           <th>Shop</th>
//                           <th>Product</th>
//                           <th>Device</th>
//                           <th>Duration</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {selectedUser.recentEvents.map((event, index) => (
//                           <tr key={index}>
//                             <td>{formatDate(event.visitedAt)}</td>
//                             <td>
//                               <span className="va-event-badge">{event.eventName}</span>
//                             </td>
//                             <td>
//                               {event.pageMetadata?.pageName ? (
//                                 <span
//                                   className="va-page-badge"
//                                   style={{
//                                     backgroundColor: getPageBadgeColor(
//                                       event.pageMetadata.pageName
//                                     ),
//                                   }}
//                                 >
//                                   {event.pageMetadata.pageName}
//                                 </span>
//                               ) : (
//                                 '-'
//                               )}
//                             </td>
//                             <td className="va-monospace">
//                               {event.pageMetadata?.shopName ? (
//                                 <span className="va-shop-badge">
//                                   🏪 {event.pageMetadata.shopName}
//                                 </span>
//                               ) : (
//                                 '-'
//                               )}
//                             </td>
//                             <td className="va-monospace">
//                               {event.pageMetadata?.productName ? (
//                                 <span className="va-product-badge">
//                                   📦 {event.pageMetadata.productName}
//                                 </span>
//                               ) : (
//                                 '-'
//                               )}
//                             </td>
//                             <td>
//                               <span className="va-device-badge">
//                                 {getDeviceIcon(event.deviceType)} {event.deviceType}
//                               </span>
//                             </td>
//                             <td>{getEventDuration(event)}</td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>

//               <div className="va-modal-footer">
//                 <button
//                   type="button"
//                   onClick={() => setShowModal(false)}
//                   className="va-btn va-btn-primary"
//                 >
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from 'react';
import apiWithAuth from '../../services/apiWithAuth';
import './VisitorAnalytics.css';

// ─── Formatting helpers ─────────────────────────────────────────────────────

function formatDate(iso) {
  if (!iso) return '-';
  try {
    return new Date(iso).toLocaleString('en-IN', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  } catch { return iso; }
}

function formatNumber(num) {
  if (!num) return '0';
  return num.toLocaleString('en-IN');
}

function formatDuration(ms) {
  if (!ms || ms === 0) return '-';
  const seconds = Math.floor(ms / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ${seconds % 60}s`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ${minutes % 60}m`;
}

function getEventDuration(event) {
  if (event.eventParams?.time_spent_ms) return formatDuration(event.eventParams.time_spent_ms);
  if (event.eventParams?.session_duration_ms) return formatDuration(event.eventParams.session_duration_ms);
  return formatDuration(event.duration);
}

function getDeviceIcon(deviceType) {
  switch (deviceType?.toLowerCase()) {
    case 'mobile': return '📱';
    case 'tablet': return '📱';
    case 'desktop': return '💻';
    default: return '❓';
  }
}

function getPageBadgeColor(pageName) {
  const colors = {
    home: '#3b82f6', shop: '#8b5cf6', product: '#ec4899',
    category: '#f59e0b', cart: '#10b981', checkout: '#ef4444', profile: '#6366f1',
  };
  return colors[pageName?.toLowerCase()] || '#6b7280';
}

// ─── Main Component ─────────────────────────────────────────────────────────

export default function VisitorAnalytics() {
  const [adminKey, setAdminKey] = useState('');
  const [search, setSearch] = useState('');
  const [limit, setLimit] = useState(100);
  const [loading, setLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [error, setError] = useState('');
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const hasRows = useMemo(() => rows.length > 0, [rows]);

  const loadData = async () => {
    setLoading(true);
    setError('');
    try {
      const qs = new URLSearchParams({
        limit: String(limit || 100),
        ...(search.trim() && { search: search.trim() }),
        ...(adminKey.trim() && { adminKey: adminKey.trim() }),
      });
      const response = await apiWithAuth.get(
        `/website-main/visitor-events?${qs.toString()}`,
        { headers: adminKey.trim() ? { 'x-admin-key': adminKey.trim() } : {} }
      );
      const json = response.data;
      if (!json?.success) throw new Error(json?.error || 'Failed to fetch visitor logs');
      setRows([
        ...(Array.isArray(json.data) ? json.data : []),
        ...(Array.isArray(json.guests) ? json.guests : []),
      ]);
      setHasLoaded(true);
    } catch (e) {
      setRows([]);
      setError(e?.message || 'Failed to fetch visitor logs');
    } finally {
      setLoading(false);
    }
  };

  const loadSummary = async () => {
    setSummaryLoading(true);
    try {
      const qs = new URLSearchParams({
        ...(adminKey.trim() && { adminKey: adminKey.trim() }),
      });
      const response = await apiWithAuth.get(
        `/website-main/visitor-events/summary?${qs.toString()}`,
        { headers: adminKey.trim() ? { 'x-admin-key': adminKey.trim() } : {} }
      );
      const json = response.data;
      if (json?.success) setSummary(json.data);
    } catch (e) {
      console.error('Failed to load summary:', e);
    } finally {
      setSummaryLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    loadSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!autoRefresh) return undefined;
    const interval = setInterval(() => { loadData(); loadSummary(); }, 2000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoRefresh, adminKey, search, limit]);

  return (
    <div className="visitor-analytics">
      <div className="va-container">

        {/* Header */}
        <div className="va-header">
          <div>
            <h1 className="va-title">Visitor Analytics</h1>
            <p className="va-subtitle">Real-time tracking of user interactions and page visits</p>
          </div>
        </div>

        {/* Summary Cards */}
        {summary && (
          <div className="va-summary-cards">
            <div className="va-card">
              <div className="va-card-icon">📊</div>
              <div className="va-card-content">
                <h3 className="va-card-label">Total Events</h3>
                <p className="va-card-value">{formatNumber(summary.totalEvents)}</p>
              </div>
            </div>
            <div className="va-card">
              <div className="va-card-icon">👥</div>
              <div className="va-card-content">
                <h3 className="va-card-label">Unique Users</h3>
                <p className="va-card-value">{formatNumber(summary.uniqueUsers)}</p>
              </div>
            </div>
            <div className="va-card">
              <div className="va-card-icon">📄</div>
              <div className="va-card-content">
                <h3 className="va-card-label">Top Page</h3>
                <p className="va-card-value">{summary.topPages?.[0]?._id || '-'}</p>
                <p className="va-card-count">{formatNumber(summary.topPages?.[0]?.count || 0)} visits</p>
              </div>
            </div>
            <div className="va-card">
              <div className="va-card-icon">⚡</div>
              <div className="va-card-content">
                <h3 className="va-card-label">Top Event</h3>
                <p className="va-card-value">{summary.topEvents?.[0]?._id || '-'}</p>
                <p className="va-card-count">{formatNumber(summary.topEvents?.[0]?.count || 0)} times</p>
              </div>
            </div>
          </div>
        )}

        {/* Controls */}
        <div className="va-controls">
          <div className="va-control-group">
            <input type="password" value={adminKey} onChange={(e) => setAdminKey(e.target.value)}
              placeholder="Admin key (if enabled)" className="va-input" />
            <input type="text" value={search} onChange={(e) => setSearch(e.target.value)}
              placeholder="Search by name, email, phone, event, or page..." className="va-input va-input-wide" />
            <div className="va-control-actions">
              <input type="number" min={1} max={500} value={limit}
                onChange={(e) => setLimit(Number(e.target.value || 100))} className="va-input-number" />
              <button type="button" onClick={() => { loadData(); loadSummary(); }}
                disabled={loading || summaryLoading} className="va-btn va-btn-primary">
                {loading || summaryLoading ? '⏳ Loading...' : '🔄 Load'}
              </button>
            </div>
          </div>
          <div className="va-refresh-toggle">
            <span className="va-refresh-label">
              Auto-refresh every 2s
              {autoRefresh && <span className="va-pulse">●</span>}
            </span>
            <button type="button" onClick={() => setAutoRefresh((v) => !v)}
              className={`va-btn ${autoRefresh ? 'va-btn-pause' : 'va-btn-resume'}`}>
              {autoRefresh ? '⏸ Pause' : '▶ Resume'}
            </button>
          </div>
        </div>

        {error && (
          <div className="va-error">
            <span>⚠️ {error}</span>
            <button onClick={() => setError('')} className="va-error-close">✕</button>
          </div>
        )}

        {/* Table */}
        <div className="va-table-wrapper">
          <table className="va-table">
            <thead>
              <tr>
                <th>User</th><th>Email</th><th>Phone</th><th>Total Events</th>
                <th>First Seen</th><th>Last Seen</th><th>Device Types</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {!hasRows && (
                <tr className="va-empty-row">
                  <td colSpan={8}>
                    {hasLoaded ? '📭 No records found. Try adjusting your filters.' : '⏳ Loading visitor logs...'}
                  </td>
                </tr>
              )}
              {rows.map((user) => (
                <tr key={user.userId || 'guest'} className="va-data-row">
                  <td className="va-user">
                    <div className="va-user-info">
                      <div className="va-user-name">{user.isGuest ? '👤 Guest Users' : user.fullName || '-'}</div>
                      {!user.isGuest && user.userId && (
                        <div className="va-user-id">ID: {user.userId.slice(-6)}</div>
                      )}
                    </div>
                  </td>
                  <td className="va-email">{user.email || '-'}</td>
                  <td className="va-phone">{user.phone || '-'}</td>
                  <td className="va-events">{formatNumber(user.stats.totalEvents)}</td>
                  <td className="va-first-seen">{formatDate(user.stats.firstSeen)}</td>
                  <td className="va-last-seen">{formatDate(user.stats.lastSeen)}</td>
                  <td className="va-devices">
                    <span className="va-device-badges">
                      {user.activity.deviceTypes.map((device, index) => (
                        <span key={index} className="va-device-badge">
                          {getDeviceIcon(device)} {device}
                        </span>
                      ))}
                    </span>
                  </td>
                  <td className="va-action">
                    <button type="button"
                      onClick={() => { setSelectedUser(user); setShowModal(true); }}
                      className="va-btn-details">
                      View Activity
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="va-footer">
          <span className="va-count">Showing <strong>{rows.length}</strong> record{rows.length === 1 ? '' : 's'}</span>
        </div>

        {/* Details Modal */}
        {showModal && selectedUser && (
          <div className="va-modal-overlay" onClick={() => setShowModal(false)}>
            <div className="va-modal va-modal-large" onClick={(e) => e.stopPropagation()}>
              <div className="va-modal-header">
                <h2>User Activities</h2>
                <button type="button" onClick={() => setShowModal(false)} className="va-modal-close">✕</button>
              </div>
              <div className="va-modal-content">
                <div className="va-modal-grid">
                  <div className="va-modal-section">
                    <h3 className="va-modal-section-title">User Information</h3>
                    <div className="va-modal-fields">
                      <div className="va-modal-field"><label>Name</label><span>{selectedUser.isGuest ? 'Guest' : selectedUser.fullName || '-'}</span></div>
                      <div className="va-modal-field"><label>Phone</label><span>{selectedUser.phone || '-'}</span></div>
                      <div className="va-modal-field"><label>Email</label><span>{selectedUser.email || '-'}</span></div>
                      <div className="va-modal-field"><label>User ID</label><span className="va-monospace">{selectedUser.userId || '-'}</span></div>
                    </div>
                  </div>
                  <div className="va-modal-section">
                    <h3 className="va-modal-section-title">Statistics</h3>
                    <div className="va-modal-fields">
                      <div className="va-modal-field"><label>Total Events</label><span>{formatNumber(selectedUser.stats.totalEvents)}</span></div>
                      <div className="va-modal-field"><label>First Seen</label><span>{formatDate(selectedUser.stats.firstSeen)}</span></div>
                      <div className="va-modal-field"><label>Last Seen</label><span>{formatDate(selectedUser.stats.lastSeen)}</span></div>
                      <div className="va-modal-field"><label>Total Duration</label><span>{formatDuration(selectedUser.stats.totalDuration)}</span></div>
                    </div>
                  </div>
                  <div className="va-modal-section">
                    <h3 className="va-modal-section-title">Activity Summary</h3>
                    <div className="va-modal-fields">
                      <div className="va-modal-field"><label>Event Names</label><span>{selectedUser.activity.eventNames.join(', ') || '-'}</span></div>
                      <div className="va-modal-field"><label>Page Names</label><span>{selectedUser.activity.pageNames.join(', ') || '-'}</span></div>
                      <div className="va-modal-field"><label>Shop Names</label><span>{selectedUser.activity.shopNames.join(', ') || '-'}</span></div>
                      <div className="va-modal-field"><label>Device Types</label><span>{selectedUser.activity.deviceTypes.join(', ') || '-'}</span></div>
                    </div>
                  </div>
                </div>
                <div className="va-modal-section va-modal-section-full">
                  <h3 className="va-modal-section-title">Recent Activities</h3>
                  <div className="va-events-table-wrapper">
                    <table className="va-events-table">
                      <thead>
                        <tr><th>Time</th><th>Event</th><th>Page</th><th>Shop</th><th>Product</th><th>Device</th><th>Duration</th></tr>
                      </thead>
                      <tbody>
                        {selectedUser.recentEvents.map((event, index) => (
                          <tr key={index}>
                            <td>{formatDate(event.visitedAt)}</td>
                            <td><span className="va-event-badge">{event.eventName}</span></td>
                            <td>
                              {event.pageMetadata?.pageName ? (
                                <span className="va-page-badge" style={{ backgroundColor: getPageBadgeColor(event.pageMetadata.pageName) }}>
                                  {event.pageMetadata.pageName}
                                </span>
                              ) : '-'}
                            </td>
                            <td className="va-monospace">
                              {event.pageMetadata?.shopName ? <span className="va-shop-badge">🏪 {event.pageMetadata.shopName}</span> : '-'}
                            </td>
                            <td className="va-monospace">
                              {event.pageMetadata?.productName ? <span className="va-product-badge">📦 {event.pageMetadata.productName}</span> : '-'}
                            </td>
                            <td><span className="va-device-badge">{getDeviceIcon(event.deviceType)} {event.deviceType}</span></td>
                            <td>{getEventDuration(event)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="va-modal-footer">
                <button type="button" onClick={() => setShowModal(false)} className="va-btn va-btn-primary">Close</button>
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}